<template>
	<el-container class="wrap-80">
		<el-row>
			<BreadCrumb></BreadCrumb>
		</el-row>
		<div class="flex">
			<div style="flex: 1">
				<f-shipping v-if="hasPaperProduct"></f-shipping>
				<f-cart ref="cartComponent"></f-cart>
				
			</div>
			<div style="width: 400px; margin-left: 20px">
				<f-payment :hasPaperProduct="hasPaperProduct"></f-payment>
				
			</div>
		</div>
	</el-container>
</template>

<script>
import FShipping from './components/FShipping.vue';
import FCart from './components/FCart.vue';
import FPayment from './components/FPayment.vue';
import FInfo from './components/FInfo.vue';
import BreadCrumb from '@/components/Breadcrumb/index.vue';
import { mapState, mapActions } from 'vuex';

export default {
	data() {
		return {};
	},
	components: {
		FShipping,
		FCart,
		FPayment,
		BreadCrumb,
		FInfo
	},
	computed: {
		...mapState('Cart', ['hasPaperProduct'])
	},
	methods: {
		...mapActions('Settings', ['setBreadcrumbList'])
	},
	created() {
		const breadcrumbs = [
			{
				path: '/Home',
				name: '首页'
			},
			{
				path: '/Cart',
				name: '购物车'
			},
			{
				name: '商品结算'
			}
		];
		this.setBreadcrumbList(breadcrumbs);
	}
};
</script>

<style lang="less" scoped>
.confirm-bottom {
	position: fixed;
	background-color: #ffffff;
	width: 100%;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 10;
	padding: 25px 6%;
	box-sizing: border-box;
	color: #333333;
	font-size: 14px;
	box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.05);
	border-radius: 12px 12px 0px 0px;
	b {
		font-size: 20px;
		color: #ec2b2d;
	}
	.confirm-leftbox {
		color: #888888;
		span {
			margin-left: 30px;
		}
	}
	.cartbox {
		margin-right: 30px;
		strong {
			color: #ec2b2d;
			font-weight: 400;
		}
	}
	.pricebox {
		margin-right: 30px;
		.price {
			margin-bottom: 5px;
		}
		small {
			margin-left: 8px;
		}
	}
}
.emptybox {
	text-align: center;
	padding-bottom: 50px;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.wrap-80 {
		width: 96%;
	}
	.confirm-bottom {
		flex-direction: column;
		align-items: flex-end;
		.confirm-leftbox {
			width: 100%;
			margin-bottom: 15px;
			text-align: right;
		}
	}
}
@media (min-width: 1080px) and (max-width: 1920px) {
	.shipitem {
		flex: 0 1 23.4%;
	}
}
</style>